export default __webpack_public_path__ + "b49f99570c0eafc39df79bc000484c6c.svg";